import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const PortalHelp = () => {  
  useEffect(() => {
    document.title = 'Portal (Help?) - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                     
                    <li>Portal (Help?)</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                        <div className="col-lg-12">
                        <h3> CampusCare® Application Guidelines &amp; Instructions </h3>
                        <div className="clr10"></div>
                        <p className="guideheading"><strong>How to LOG IN Parent Portal?</strong></p>
                        <div className="clr10"></div>
                        <p className="details"> 1. Open Chrome <img src="https://webapi.entab.info/api/image/SFXH/public/images/google.png" width="68" height="20"
                                alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> OR Mozilla <img src="https://webapi.entab.info/api/image/SFXH/public/images/mzilla.png" width="60"
                                height="20" alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> or Internet <img data
                                src="https://webapi.entab.info/api/image/SFXH/public/images/internet.png" width="18" height="20"
                                alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> </p>
                        <p className="details"> 2. Write the school URL <strong><a target="_blank"
                                    href="https://entab.online/SXSHIR">"sfxhisar.campuscare.info"</a></strong> in address bar.
                            (you will be routed to the Log In credential page).</p>
                        <p className="details"> 3. Then, enter the USER ID and Click on "Next button", Then enter
                            PASSWORD and Click on Sign in button.</p>
                        <p className="details">Once logged in, you are welcomed with various information
                            relating to assignments, news, circulars, date sheet, fee details etc. that
                            are self explanatory. Wish you to go through every links that are
                            provided and explore more.</p>
            
                        <div className="clr10"></div>
                        <p className="guideheading"><strong>How to RESET PASSWORD in Parent Portal? </strong></p>
                        <div className="clr10"></div>
                        <p className="details"> 1. Open Chrome <img src="https://webapi.entab.info/api/image/SFXH/public/images/google.png" width="68" height="20"
                                alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> OR Mozilla <img src="https://webapi.entab.info/api/image/SFXH/public/images/mzilla.png" width="60"
                                height="20" alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> or Internet <img data
                                src="https://webapi.entab.info/api/image/SFXH/public/images/internet.png" width="18" height="20"
                                alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> </p>
                        <p className="details"> 2. Write the school URL <strong><a target="_blank"
                                    href="https://entab.online/SXSHIR">"sfxhisar.campuscare.info"</a></strong> in address bar.
                            (you will be routed to the Log In credential page).</p>
                        <p className="details">3. Then, click on “Forgot User ID or Password?” text given below User ID field.</p>
                        <p className="details">4. Select the User Type (For which you want a password) then Enter Registered Mobile No.
                            and click on “Reset” Button.</p>
                        <p className="details">5. You will get an SMS on your registered mobile no. along with login credentials.
                        </p>
                        <div className="clr10"></div>
                        <div>
                            <p className="guideheading"><strong> How to Install &amp; operate MOBILE APP? </strong></p>
                            <p>1. Go to <img src="https://webapi.entab.info/api/image/SFXH/public/images/playstore.png" width="79" height="20"
                                    alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> Store / <img src="https://webapi.entab.info/api/image/SFXH/public/images/apple.png"
                                    width="89" height="20" alt="School ERP Software, Mobile App, School Management Software"
                                    className="img-fluid"/> and Search
            
                                "CampusCare®". </p>
                            <p> 2. Install and open the <a href="https://www.entab.in/mobile-apps.html"><b>Mobile App</b></a>.</p>
                            <p>3. Enter school web portal URL: <strong><a target="_blank"
                                        href="https://entab.online/SXSHIR">"sfxhisar.campuscare.info"</a></strong> in link bar
                                &amp; verify. </p>
                            <p>4. After verifying, you will get an option for User ID &amp; Password.</p>
                            <p>Once logged in, you are welcomed with various information relating to assignments, news. circulars,
                                date sheet, fee details etc that are self Explanatory. Wish you to go through every links that are
            
                                provided and explore more. </p>
                            <p><strong>NOTE* :</strong> Kindly update your <a href="https://www.entab.in/mobile-apps.html"><b>Mobile
                                        Apps</b></a> time to time to avoid difficulties during usage.</p>
                        </div>
                        <div className="clr10"></div>
                        <div>
                            <p className="guideheading"><strong>How to make Online Payment? :-</strong> </p>
                            <p> 1. Open Google Chrome <img src="https://webapi.entab.info/api/image/SFXH/public/images/google.png" width="68" height="20"
                                    alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> / Mozilla Firefox <img
                                    src="https://webapi.entab.info/api/image/SFXH/public/images/mzilla.png" width="60" height="20"
                                    alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> or Internet Explorer <img
                                    src="https://webapi.entab.info/api/image/SFXH/public/images/internet.png" width="18" height="20"
                                    alt="School ERP Software, Mobile App, School Management Software" className="img-fluid"/> </p>
                            <p> 2. Enter the school URL <strong><a target="_blank"
                                        href="https://entab.online/SXSHIR">"sfxhisar.campuscare.info"</a></strong> address bar
                                and you will be routed to the Log In page.</p>
                            <p> 3. Now, enter the USER ID and then enter your PASSWORD and Click on ‘Sign in’ button.</p>
                            <p> 4. After login, click on the Online Payment menu.</p>
                            <p> 5. Select the installment to pay &amp; click on the proceed button.</p>
                            <p> 6. Now, you will be redirected to Payment Gateway page.</p>
                            <p> 7. Choose the Pay mode : Credit Card/Debit Card/Net banking &amp; fill the details to complete the
                                payment process.</p>
                            <p> 8. After successful payment, you will receive the fee receipt &amp; SMS on successful fee payment.
                            </p>
                            <div className="clr25"></div>
                            <p><b>Note :-</b><i> If for any reason, the fee payment output details are not displayed on your screen
                                    after you have made payments, please check the details in “My Payment” in Finance link. If your
                                    accounts get debited/deducted and receipt is not available, you are advised to contact school
                                    office or mail us.</i></p>
                        </div>
            
            
                        <div className="clr10"></div>
                        <div className="assistance">
                            <h3 className="guideheading">Please call or write for assistance:</h3>
                            <p className="details"><strong> <a href="https://www.entab.in/contact-us.html">PARENT HELP DESK</a></strong>
                                ( 8 AM to 8:00 PM ) - <strong>Tele No.</strong> 011- 43193333 - Ext : 5,<strong> E-Mail :</strong>
                                <strong><a href="mailto:parentdesk@entab.in" className="yellow-link"> parentdesk@entab.in</a></strong>
                            </p>
                        </div>
                        </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default PortalHelp;
